import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SGKC012AService, Sgkc012aRequest, Sgkc012aResponse } from 'sg-api';

/**
 * スライド調整単価詳細取得API使用サービス
 * @export
 * @class UsedSgkc012aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc012aService {

    /** スライド調整単価詳細取得結果の結果のSubject */
    private _tankatableAuthorityInformationResult$: Subject<Sgkc012aResponse> = new Subject<Sgkc012aResponse>();

    /**
   * コンストラクタ
   * @param {SGKC012AService} sGKC012AService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgkc012aService
   */
    constructor(
        private sGKC012AService: SGKC012AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
    ) { }

    /**
     *  スライド調整単価詳細取得結果のobservable提供
     * @readonly
     * @memberof UsedSgkc012aService
     */
    get slideTankatableChanges() {
        return this._tankatableAuthorityInformationResult$.asObservable();
    }

    /**
       *  スライド調整単価詳細取得API呼び出し
       * @param {Sgkc012aRequest} value - スライド調整単価詳細取得APIのリクエストパラメータ
       * @return {Observable<Sgkc012aResponse>} スライド調整単価詳細取得APIのレスポンス
       * @memberof UsedSgkc012aService
       */
    getSlideTankatableDetails(value: Sgkc012aRequest): Observable<Sgkc012aResponse> {
        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(value, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        // 検索条件を保存
        return this.sGKC012AService.kC10RSGKC012APost(<Sgkc012aRequest>this.apiCommonService.setRequestCommon(value), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    this._tankatableAuthorityInformationResult$.next(response.body);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC012A');
                    return throwError(err.message);
                })
            );
    }
}
